module.exports = __webpack_public_path__ + "img/car_front_right_outline.55da3304.svg";